import { diContainer, serviceNames } from '../diContainer/diContainer';
import CompanyBillingDetailsRepository from '../repositories/CompanyBillingDetailsRepository';
import CompanyBillingDetails from '../domain/entities/CompanyBillingDetails';
import TransactionLoadHandler, { ITransactionLoad } from './TransactionLoadHandler';
import { FIELD_TYPE } from '../constants/Constants';

class SaveCompanyBillingDetailsUseCase extends TransactionLoadHandler {

  private companyBillingDetailsRepository: CompanyBillingDetailsRepository;

  constructor(options?: ITransactionLoad) {
    super(options?.transactionLoadOptions);

    this.transactionRepository = diContainer.get(
      serviceNames.transactionRepository,
    );
    this.companyBillingDetailsRepository = diContainer.get(
      serviceNames.companyBillingDetailsRepository,
    );
  }

  protected async run(): Promise<void> {
    try {
      const { transactionRepository, companyBillingDetailsRepository } = this;

      const transaction = await transactionRepository.getTransaction();

      let { companyBillingDetails } = transaction;
      const { [FIELD_TYPE.BILL_TO_COMPANY]: billToCompany } = companyBillingDetails.attributes;

      if (billToCompany) {
        // eslint-disable-next-line max-len
        const updatedCompanyBillingDetails = companyBillingDetailsRepository.formStore.toCompanyBillingDetails();

        companyBillingDetails = CompanyBillingDetails.fromJSON({
          ...updatedCompanyBillingDetails.attributes,
          [FIELD_TYPE.BILL_TO_COMPANY]: billToCompany,
        });
      } else {
        companyBillingDetails = new CompanyBillingDetails();
      }
      await this.companyBillingDetailsRepository.updateCompanyBillingDetails(
        companyBillingDetails,
      );
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
}

export default SaveCompanyBillingDetailsUseCase;
